import React, { memo } from 'react';
import PropTypes from 'prop-types';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { Award } from 'lucide-react';
import CardImage from '../Views/CardImage';
import { vocabTitle } from '../../../helpers/content';

const FlexCompetitionCard = memo(({ item, compact, hideLink, gridLayout }) => {
  const typeLabel = vocabTitle(item.type_of_competition);

  const titleBlock = (
    <>
      {typeLabel && <h6 className="cards__subtitle">{typeLabel}</h6>}
      <h4 className="cards__title">
        {item.title ? item.title : item.id}
        {item.is_best_result && (
          <Award
            size={16}
            className="cards__title-icon"
            aria-label="Best Result / Award"
          />
        )}
      </h4>
    </>
  );

  return (
    <div
      className={`cards__item ${gridLayout ? 'cards__item--grid' : 'cards__item--fullwidth'}`}
    >
      {!compact && (
        <CardImage
          item={item}
          fallback={'/competition_default_image.svg'}
          gridLayout={gridLayout}
          href={hideLink ? undefined : item['@id']}
        />
      )}
      <div className="cards__content">
        {hideLink ? (
          titleBlock
        ) : (
          <UniversalLink href={item['@id']}>{titleBlock}</UniversalLink>
        )}
        {item.competition_location && (
          <p className="cards__info">{item.competition_location}</p>
        )}
        {item.description && (
          <p className="cards__description">{item.description}</p>
        )}
      </div>
    </div>
  );
});

FlexCompetitionCard.displayName = 'FlexCompetitionCard';

FlexCompetitionCard.propTypes = {
  item: PropTypes.shape({
    '@id': PropTypes.string.isRequired,
    title: PropTypes.string,
    id: PropTypes.string,
    description: PropTypes.string,
    type_of_competition: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({ title: PropTypes.string }),
    ]),
    competition_location: PropTypes.string,
    is_best_result: PropTypes.bool,
    image_caption: PropTypes.string,
  }).isRequired,
  compact: PropTypes.bool,
  hideLink: PropTypes.bool,
  gridLayout: PropTypes.bool,
};

export default FlexCompetitionCard;
